import { type ReduxUser, type ContentObjectRedux, isProgramContentObject } from 'models';
import { canManageCommunityRedux } from './canManageCommunity';

const areAllCommunitiesPublic = (contentObject: ContentObjectRedux) => {
  return contentObject.post_in_communities.every((community) => community.privacy === 'public');
};

const isAdmin = (contentObject: ContentObjectRedux, viewer: ReduxUser) => {
  return contentObject.post_in_communities.some((community) => canManageCommunityRedux({ viewer, community }));
};

export const canShareContentObjectRedux = ({
  viewer,
  contentObject,
}: {
  viewer: ReduxUser;
  contentObject: ContentObjectRedux;
}) => {
  if (isProgramContentObject(contentObject)) {
    return false;
  }

  return areAllCommunitiesPublic(contentObject) || isAdmin(contentObject, viewer);
};
